import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ButtonType =
  'primary-blue-1'
  | 'primary-blue-2'
  | 'primary-blue-3'
  | 'primary-yellow'
  | 'secondary-blue'
  | 'secondary-yellow'
  | 'secondary-magenta'
  | 'primary-magenta'
  | 'otp-light-green'
  | 'otp-dark-green'
  | 'ephzhb-blue'
  | 'ephzhb-yellow';
@Component({
  selector: 'psc-button',
  styleUrls: ['button.component.scss'],
  templateUrl: './button.component.html'
})
export class ButtonComponent {
  @Input() label: string = '';
  @Input() type: ButtonType = 'primary-blue-1';
  @Input() size: 'tiny' | 'small' | 'regular' = 'regular';
  @Input() disabled: boolean = false;
  @Input() width: number;
  @Input() bold: boolean;

  @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();

}
